
export function isFlagOn(flag) {
    return isFlagOnProjectOn(flag) || isFlagOnUserOn(flag);
}

export function isFlagOnProjectOn(flag) {
    if (window.auth && window.auth.project && window.auth.project.FeatureFlags) {
        const ff = window.auth.project.FeatureFlags;

        if (ff.indexOf) {
            return ff.indexOf(flag) !== -1;
        }
    }

    return false;
}

export function isFlagOnUserOn(flag) {
    if (window.auth && window.auth.user && window.auth.user.CurrentCompany && window.auth.user.CurrentCompany.FeatureFlags) {
        const ff = window.auth.user.CurrentCompany.FeatureFlags;

        if (ff.indexOf) {
            return ff.indexOf(flag) !== -1;
        }
    }

    return false;
}

export function isInPricingPlan(flag, skipTrialCheck = false) {
    if (window.auth && window.auth.user && window.auth.user.CurrentCompany) {

        if (!skipTrialCheck && window.auth.user.CurrentCompany.IsInTrial) return true;

        if (window.auth.user.CurrentCompany.EnabledFeatures) {
            const ff = window.auth.user.CurrentCompany.EnabledFeatures;

            if (ff.indexOf) {
                const result = ff.indexOf(flag) !== -1;

                if (result) return true;
            }
        }

        return isFlagOn(flag);
    }

    return false;
}

export function isInTrial() {
    return window.auth.user.CurrentCompany.IsInTrial === true;
}